
<div style="display: flex; align-items: center; justify-content: space-between; padding: 1rem;">
  <!-- <h5 style="text-align: center; width: 100%; margin-bottom: 0; line-height: 1.5; border-bottom: none;">Lead Details</h5> -->
  <h5 style="align-self: center; margin: 0; text-align: center; width: 100%; font-size: 1.0625rem; font-family: Roboto; font-weight: 300;">Lead Detail</h5>

  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <!-- <button type="button" class="close" (click)="close()" aria-label="Close" style="color: #999; padding: 1rem; margin: -1rem -1rem -1rem auto;">
    <span aria-hidden="true">&times;</span>
  </button> -->

</div>

<mat-dialog-content class="mat-typography">
  <mat-tab-group (selectedTabChange)="activeTabIndex = $event.index">
    
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style="margin-right: 8px;">info</mat-icon>
        Lead Information
      </ng-template>

      <section class="container-buttons-right">
        <mat-slide-toggle [(ngModel)]="slideToggleState" (change)="onToggleChange($event)" class="toggle">Edit</mat-slide-toggle>
      </section>

      <section class="content-tab">

      

        <section class="layout-form-x3" style="padding-top: 8px">
        <mat-form-field >
          <mat-label>ID</mat-label>
          <input matInput type="number" name="ID" [(ngModel)]="data.contact.id" disabled />
        </mat-form-field>

        <mat-form-field >
          <mat-label>Name</mat-label>
          <input matInput type="text" name="contactName" [(ngModel)]="data.contact.name" [disabled]="editContact" />
        </mat-form-field>
        
        <mat-form-field >
          <mat-label>Company</mat-label>
          <input matInput type="text" name="contactCompany" [(ngModel)]="data.contact.company" [disabled]="editContact" />
        </mat-form-field>

        <mat-form-field >
          <mat-label>Date</mat-label>
          <input matInput type="text" name="Date" value="{{data.contact.fecha * 1000 | date:'MM-dd-yyyy' }}" disabled />
        </mat-form-field>
        
        <mat-form-field >
          <mat-label>Email</mat-label>
          <input matInput type="text" name="Email" [(ngModel)]="data.contact.email" [disabled]="editContact" />
        </mat-form-field>
        
        <mat-form-field >
          <mat-label>Phone</mat-label>
          <input matInput type="text" name="phone" [(ngModel)]="data.contact.phone" [disabled]="editContact" />
        </mat-form-field>

        <mat-form-field >
          <mat-label>Are you looking to buy, sell or recycle IT
            equipment?</mat-label>
          <mat-select name="whatareyoulooking" matNativeControl [(ngModel)]="data.contact.whatareyoulooking" [disabled]="editContact">
          <mat-option value="Buy IT Equipment">Buy IT Equipment</mat-option>
          <mat-option value="Sell IT Equipment">Sell IT Equipment</mat-option>
          <mat-option value="Recycle IT Equipment">Recycle IT Equipment</mat-option>
          <mat-option value="Other">Other</mat-option>
        </mat-select>
        </mat-form-field>
        
        <mat-form-field >
          <mat-label>From URL</mat-label>
          <input matInput type="text" name="Source / Reference" [(ngModel)]="data.contact.reference" disabled />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Source</mat-label>
          <mat-select name="source" matNativeControl [(ngModel)]="data.contact.source" placeholder="Source"
            [disabled]="editContact">
            <mat-option *ngFor="let source of sources" value="{{ source }}">
              {{ source }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
      </section>
      <section>
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Description</mat-label>
          <textarea matInput placeholder="Description..." [(ngModel)]="data.contact.descripcion" name="descripcion" class="form-control" name="contactDescription" [disabled]="editContact" rows="4"></textarea>
        </mat-form-field>

        <!-- <div class="form-group">
          <label class="bmd-label-floating">Description</label>
          <div class="form-group">
            <textarea name="descripcion" class="form-control" name="contactDescription"
              [(ngModel)]="data.contact.descripcion" [readonly]="editContact"></textarea>
          </div>
        </div> -->
      </section>

      <div style="padding-top: 16px" class="d-flex">
        <h4 style="font-family: 'Roboto'; font-size: 16px; font-weight: 600; color: #000">Lead Location</h4>
        <mat-icon style="margin-left: 8px;" matTooltip="This location is captured when the lead visits the website and is not necessarily where the equipment is.">info</mat-icon>
      </div>

      <section class="layout-form-x3">
        <mat-form-field *ngIf="data.contact?.ipinfoCity">
          <mat-label>City</mat-label>
          <input matInput type="text" name="ipinfoCity" [(ngModel)]="data.contact.ipinfoCity" disabled />
        </mat-form-field>
        <mat-form-field *ngIf="data.contact?.ipinfoRegionname">
          <mat-label>State</mat-label>
          <input matInput type="text" name="ipinfoRegionname" [(ngModel)]="data.contact.ipinfoRegionname" disabled />
        </mat-form-field>
        <mat-form-field *ngIf="data.contact?.ipinfoZip">
          <mat-label>Zip</mat-label>
          <input matInput type="text" name="ipinfoZip" [(ngModel)]="data.contact.ipinfoZip" disabled />
        </mat-form-field>
        <mat-form-field *ngIf="data.contact?.ipinfoCountry">
          <mat-label>Country</mat-label>
          <input matInput type="text" name="ipinfoCountry" [(ngModel)]="data.contact.ipinfoCountry" disabled />
        </mat-form-field>
        <mat-form-field *ngIf="data.contact?.ipinfoTimezone">
          <mat-label>Timezone</mat-label>
          <input matInput type="text" name="ipinfoTimezone" [(ngModel)]="data.contact.ipinfoTimezone" disabled />
        </mat-form-field>
      
      </section>

      <div style="padding-top: 16px" class="d-flex">
        <h4 style="font-family: 'Roboto'; font-size: 16px; font-weight: 600; color: #000">Equipment Location</h4>
        <mat-icon style="margin-left: 8px;" matTooltip="This fields are filled with data captured on the contact form of the web page when the lead comes from the website.">info</mat-icon>
      </div>

      <section class="layout-form-x3">
        
        <mat-form-field *ngIf="data.contact?.country?.country && editContact">
          <mat-label>Country</mat-label>
          <input matInput type="text" name="Country" [(ngModel)]="data.contact.country.country" disabled />
        </mat-form-field>
        <mat-form-field *ngIf="data.contact?.state?.state && editContact">
          <mat-label>State</mat-label>
          <input matInput type="text" name="State" [(ngModel)]="data.contact.state.state" disabled />
        </mat-form-field>
        <mat-form-field *ngIf="data.contact?.city?.city && editContact">
          <mat-label>City</mat-label>
          <input matInput type="text" name="City" [(ngModel)]="data.contact.city.city" disabled />
        </mat-form-field>

        <!-- Country Select -->
        <mat-form-field appearance="fill" *ngIf="!editContact">
          <mat-label>Country</mat-label>
          <mat-select [(ngModel)]="data.contact.country.id" (selectionChange)="getStates()" [disabled]="editContact">
            <mat-option *ngFor="let country of countries" [value]="country.id">{{ country.country }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- State Autocomplete -->
        <mat-form-field appearance="fill" *ngIf="!editContact">
          <mat-label>State</mat-label>
          <input type="text" matInput [matAutocomplete]="autoState" [formControl]="stateControl">
          <mat-autocomplete #autoState="matAutocomplete" (optionSelected)="onStateSelected($event)">
            <mat-option *ngFor="let state of filteredStates | async" [value]="state.state">
              {{ state.state }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      
        <!-- City Autocomplete -->
        <mat-form-field appearance="fill" *ngIf="!editContact">
          <mat-label>City</mat-label>
          <input type="text" matInput [matAutocomplete]="autoCity" [formControl]="cityControl">
          <mat-autocomplete #autoCity="matAutocomplete" (optionSelected)="onCitySelected($event)">
            <mat-option *ngFor="let city of filteredCities | async" [value]="city.city">
              {{ city.city }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        
      </section>

      <section class="container-buttons-right" style="margin: 16px 0px;">

        <button class="gts-btn-primary-outline" matRipple *ngIf="!editContact" (click)="cleanFormLeadInformation()">
          <!-- <span class="gts-btn-icon-left">cancel</span> -->
          <span class="gts-btn-text">Cancel</span>
        </button>

        <button class="gts-btn-primary" matRipple *ngIf="!editContact" (click)="editContactFunction()">
          <!-- <span class="gts-btn-icon-left">save</span> -->
          <span class="gts-btn-text">Save changes</span>
        </button>

      </section>

      </section>
      
      

    </mat-tab>
  
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style="margin-right: 8px;">star</mat-icon>
        Lead Ranking
      </ng-template>
      <section class="content-tab">
        <!-- <div *ngIf="!editHistory">
          <div style="margin-top: 30px">
            <h4 class="mb-2" *ngIf="statusLead == '' || statusLead == null">
              Please Rate This Lead!
            </h4>
      
            <h4 *ngIf="statusLead != ''" style="font-weight: 500; color: coral; text-align: center;">
              {{statusLead}}
            </h4>
          </div>
        </div> -->

        
        <div style="text-align: center;  font-size: 16px; font-family: 'Roboto'; margin-top: 32px;">
          <p *ngIf="statusLead != ''">Lead Ranking: "<b class="text-bold">{{statusLead === 'Great' || statusLead === 'Okay' || statusLead === 'Poor' ? statusLead+' Lead' : statusLead}}</b>" </p>
          <p *ngIf="statusLead != ''">If you need to update the ranking, click on any card</p>
          <p *ngIf="statusLead == '' || statusLead == null">Please Rate This Lead!</p>
        </div>

        <div class="containerCardRankingLead" *ngIf="!editHistory">
          <div *ngFor="let ranking of rankings">
            <div class="cardimagen" (click)="setranking(ranking.value)"
              [ngClass]="[this.statusLead == ranking.value ? 'card-imagen-selected' : '']">
              <img [src]="ranking.src" width="100%" />
              <br>
              <span>{{ranking.label}}</span>
            </div>
          </div>
        </div>
        
       
      
        <!-- <div class="d-flex" *ngIf="!editHistory">
          <div *ngFor="let ranking of rankings" class="mr-2 d-flex flex-column align-items-center"
            [ngClass]="[this.statusLead == ranking.value ? 'leadselected' : '']">
            <img (click)="setranking(ranking.value)" class="imageLead mt-4" [src]="ranking.src" />
            <span class="my-4">{{ranking.label}}</span>
          </div>
          <style type="text/css">
            .imageLead {
              max-width: 60%;
              transition: transform 0.2s;
            }
      
            .imageLead:hover {
              cursor: pointer;
              transform: scale(1.5);
            }
      
            .leadselected {
              max-width: 65%;
              border: 1px solid black;
              -webkit-box-shadow: #dadada 0 0 5px;
              -moz-box-shadow: #130e0e 0 0 5px;
              box-shadow: #dadada 0 0 5px;
            }
      
            input:read-only {
              background-color: #fafafa;
              cursor: not-allowed;
            }
          </style>
        </div> -->
      </section>
      
    </mat-tab>
  
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style="margin-right: 8px;">list</mat-icon>
        Contact History
      </ng-template>
      <section class="content-tab">
        <!-- TABLE -->
        <div *ngIf="this.userinterno !== undefined" style="margin-top: 32px">
    
          <!-- TODO: IMPLEMENTS TABLE DINAMIC -->
          <dinamic-table
            *ngIf="!loading && activeTabIndex === 2"
            [id]="'contactHistoryTable'"
            [data]="contacts"
            [columnfilters]="filtros"
            [campoBusqueda]="campoBusqueda"
            [perPage]="itemsPorPagina"
            [page]="paginaActual"
            [total_items_count]="totalItems"
            [total_pages]="totalPaginas"
            [config]="options"
            (buscar)="getAllContacts($event,false)"
            (action_button)="action($event)"
            (newConfig)="updateConfig($event)"
          ></dinamic-table>

          <!-- TABLA ANTERIOR -->
          <!--<div class="material-datatables" *ngIf="tableDinamic">
            <table id="datatables1" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%"
              style="width: 100%">
              <thead>
                <tr>
                  <th>{{ tableContacts.headerRow[0] }}</th>
                  <th class="text-center">
                    {{ tableContacts.headerRow[1] }}
                  </th>
                  <th class="text-center">
                    {{ tableContacts.headerRow[2] }}
                  </th>
                  <th class="text-center">
                    {{ tableContacts.headerRow[3] }}
                  </th>
                  <th class="text-center">
                    {{ tableContacts.headerRow[4] }}
                  </th>
                  <th class="disabled-sorting text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr id="contacthistoryregistry{{row[0]}}" *ngFor="let row of tableContacts.dataRows">
                  <td>{{row[0]}}</td>
                  <td class="text-center">{{row[1]}}</td>
                  <td class="text-center">
                    {{row[2] * 1000 | date:'MM-dd-yyyy'}}
                  </td>
                  <td class="text-center">
                    {{row[3] * 1000 | date:'MM-dd-yyyy'}}
                  </td>
                  <td class="text-center">{{row[4]}}</td>
                  <td class="text-right">
                    <a (click)="getContactHistory(row[0])" class="btn btn-link btn-warning btn-just-icon" title="Edit"><i
                        class="material-icons">edit</i></a>
                    <a (click)="deleteContactHistory(row[0])" class="btn btn-link btn-danger btn-just-icon"
                      title="Delete"><i class="material-icons">delete_forever</i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>-->
    
        </div>
    
        <section>
          <button class="gts-btn-primary-basic" matRipple (click)="showFormContactH('New')" [disabled]="titleFormContactHistory==='Edit'">
            <span class="gts-btn-icon-left" *ngIf="!showFormContactHistory">add</span>
            <span class="gts-btn-icon-left" *ngIf="showFormContactHistory">remove</span>
            <span class="gts-btn-text">{{titleFormContactHistory}} Contact History</span>
          </button>
        </section>
    
        <!-- FORM -->
    
    
        <section *ngIf="this.userinterno !== undefined && showFormContactHistory">
          <section class="layout-form-x4" style="padding-top: 16px">
            <mat-form-field class="example-full-width">
              <mat-label>Purchasing REP</mat-label>
              <input matInput type="text" name="Purchasing REP" value="{{identity.name}} {{identity.surname}}" disabled />
            </mat-form-field>
    
            <mat-form-field class="example-full-width">
              <mat-label>Contact Date</mat-label>
              <input matInput [matDatepickerFilter]="dateFilter" [matDatepicker]="contactDate" name="Contact Date"
                [(ngModel)]="contacthistory.fechacontacto" />
              <mat-datepicker-toggle matIconSuffix [for]="contactDate"></mat-datepicker-toggle>
              <mat-datepicker #contactDate></mat-datepicker>
            </mat-form-field>
    
            <div>
              <p style="margin: 0px; height: 20px; color: black; font-size: 13px; ">Contact Hour</p>
              <input type="time" class="form-control" min="00:00:00" max="23:59:00" name="horacontacto"
                [(ngModel)]="contacthistory.horacontacto" />
            </div>
    
            <mat-form-field appearance="fill">
              <mat-label>Send a Reminder?</mat-label>
              <select name="reminder" id="reminder" [(ngModel)]="contacthistory.reminder" required matNativeControl>
                <option value="null" disabled>
                  Please select an option
                </option>
                <option value="YES">Yes</option>
                <option value="NO">No</option>
              </select>
            </mat-form-field>
          </section>
    
          <section class="layout-form-x4" style="padding-top: 16px" *ngIf="contacthistory.reminder == 'YES'">
    
            <mat-form-field class="example-full-width">
              <mat-label>Reminder Date</mat-label>
              <input matInput [matDatepicker]="reminderDate" [(ngModel)]="contacthistory.fecha" />
              <mat-datepicker-toggle matIconSuffix [for]="reminderDate"></mat-datepicker-toggle>
              <mat-datepicker #reminderDate></mat-datepicker>
            </mat-form-field>
    
            <div class="">
              <p style="margin: 0px; height: 20px; color: black; font-size: 13px; ">Reminder Hour</p>
              <input type="time" class="form-control" min="00:00:00" max="23:59:00" name="hora" #hora="ngModel"
                [(ngModel)]="contacthistory.hora" />
            </div>
    
            <div class="form-group">
              <mat-checkbox class="check-margin" name="email" [(ngModel)]="contacthistory.email">
                Email
              </mat-checkbox>
            </div>
    
            <div class="form-group">
              <mat-checkbox class="check-margin" name="notification" [(ngModel)]="contacthistory.notification">
                Notification
              </mat-checkbox>
            </div>
    
          </section>
    
          <mat-form-field>
            <mat-label>Things to remember</mat-label>
            <textarea matInput placeholder="Things to remember..." name="descripcion" #descripcion="ngModel"
              [(ngModel)]="contacthistory.descripcion" class="form-control" rows="4"></textarea>
          </mat-form-field>
    
          <!-- <button type="button" class="btn btn-primary" (click)="openUsersModal();" *ngIf="contacthistory.reminder == 'YES'">
                Add people to reminder
              </button> -->
    
    
          <section>
            <button class="gts-btn-primary-basic" matRipple (click)="showAddPeopleToReminder = !showAddPeopleToReminder" *ngIf="contacthistory.reminder == 'YES'">
              <span class="gts-btn-icon-left" *ngIf="!showAddPeopleToReminder">add</span>
              <span class="gts-btn-icon-left" *ngIf="showAddPeopleToReminder">remove</span>
              <span class="gts-btn-text">Add people to reminder</span>
            </button>
          </section>
    
          <section *ngIf="showAddPeopleToReminder" style="background-color: rgb(245, 245, 245); margin-top: 16px;">
    
            <div class="modal-body">
              <div class="add-people-search">
                <mat-form-field class="example-full-width">
                  <input matInput [formControl]="myControlUsers" placeholder="Search" type="text" />
                </mat-form-field>
              </div>
    
              <section class="scroll">
                <div *ngFor="let item of filteredArrayUsers | async" class="row notify">
                    <div (click)="seleccionarUser(item.id)">
                        <a class="btn btn-link btn-primary btn-just-icon">
                          <i class="material-icons">{{chequeadoUser(item.id) ? 'check_box' :
                            'check_box_outline_blank'}}</i>
                        </a>
                        <span>{{item.name | titlecase }} {{item.surname}}</span>
                    </div>
                </div>
              </section>
            </div>
    
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="closeUsersModal(1)">
                Close
              </button>
              &nbsp;&nbsp;
              <button type="button" class="btn btn-primary" (click)="closeUsersModal(2)">
                Save
              </button>
            </div> -->
    
          </section>
    
    
    
          <section class="container-buttons-right" *ngIf="this.userinterno !== undefined && editHistory" style="margin: 16px 0px;">
            <button class="gts-btn-primary-outline" matRipple (click)="cleanContact()">
              <!-- <span class="gts-btn-icon-left">cancel</span> -->
              <span class="gts-btn-text">Cancel</span>
            </button>
    
            <button class="gts-btn-primary" matRipple (click)="editContactHistory()"
              [disabled]="!contacthistory.reminder">
              <!-- <span class="gts-btn-icon-left">save</span> -->
              <span class="gts-btn-text">Save changes</span>
            </button>
    
          </section>
    
    
          <section class="container-buttons-right" *ngIf="this.userinterno !== undefined && !editHistory" style="margin: 16px 0px;">
    
            <button class="gts-btn-primary-outline" matRipple (click)="cleanContact()">
              <!-- <span class="gts-btn-icon-left">cancel</span> -->
              <span class="gts-btn-text">Cancel</span>
            </button>
    
            <button class="gts-btn-primary" matRipple (click)="onSubmit()"
              [disabled]="!contacthistory.reminder">
              <!-- <span class="gts-btn-icon-left">add</span> -->
              <span class="gts-btn-text">Contact History</span>
            </button>
    
          </section>
    
    
        </section>
    
      </section>
    
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style="margin-right: 8px;">file_present</mat-icon>
        Attached Files (<span class="animate__animated animate__fadeInUp">{{countFiles}}</span>)
      </ng-template>
      <section class="content-tab">
        <div>
          <app-multi-files *ngIf="data && data.contact && data.contact.id"
          [source]="data.contact.source"
           [idfather]="data.contact.id"[type]="'MyLeadFiles'" (total)="getCountFiles($event)">
          }
          }
          </app-multi-files>
        </div>
      </section>
      
    </mat-tab>
    
  </mat-tab-group>



</mat-dialog-content>



<!-- <div class="card">

  <div class="card-header card-header-icon card-header-rose">
    <div styles="display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <h5 style="margin: 0; padding: 0;">Lead Details</h5>
  
      <button type="button" class="close" (click)="close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
  
    </div>
  </div>

      
  <div class="card-body">
    <div mat-dialog-content>
      <form>
        <div class="row" *ngIf="!editHistory">
          <div class="row" style="width: 100%">
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>ID</mat-label>
                <input matInput type="number" name="ID" [(ngModel)]="data.contact.id" readonly />
              </mat-form-field>
            </div>
  
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Date</mat-label>
                <input matInput type="text" name="Date" value="{{data.contact.fecha * 1000 | date:'MM-dd-yyyy' }}"
                  readonly />
              </mat-form-field>
            </div>
          </div>
          <div class="row" style="width: 100%">
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Name</mat-label>
                <input matInput type="text" name="contactName" [(ngModel)]="data.contact.name" [readonly]="editContact" />
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Company</mat-label>
                <input matInput type="text" name="contactCompany" [(ngModel)]="data.contact.company"
                  [readonly]="editContact" />
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Are you looking to buy, sell or recycle IT
                  equipment?</mat-label>
                <input matInput type="text" name="whatareyoulooking" [(ngModel)]="data.contact.whatareyoulooking"
                  readonly />
              </mat-form-field>
            </div>
          </div>
          <div class="row" style="width: 100%">
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Phone</mat-label>
                <input matInput type="text" name="phone" [(ngModel)]="data.contact.phone" [readonly]="editContact" />
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Location</mat-label>
                <input matInput type="text" name="Location" [(ngModel)]="data.contact.location"
                  [readonly]="editContact" />
              </mat-form-field>
            </div>
  
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Email</mat-label>
                <input matInput type="text" name="Email" [(ngModel)]="data.contact.email" [readonly]="editContact" />
              </mat-form-field>
            </div>
          </div>
          <div class="row" style="width: 100%">
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>From URL</mat-label>
                <input matInput type="text" name="Source / Reference" [(ngModel)]="data.contact.reference" readonly />
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="fill">
                <mat-label>Source</mat-label>
                <mat-select name="source" matNativeControl [(ngModel)]="data.contact.source" placeholder="Source"
                  [readonly]="editContact">
                  <mat-option *ngFor="let source of sources" value="{{ source }}">
                    {{ source }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <h3>Equipment Location</h3>
          <div class="row" style="width: 100%">
            <div *ngIf="data.contact?.city?.city" class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>City</mat-label>
                <input matInput type="text" name="City" [(ngModel)]="data.contact.city.city" readonly />
              </mat-form-field>
            </div>
            <div *ngIf="data.contact?.state?.state" class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>State</mat-label>
                <input matInput type="text" name="State" [(ngModel)]="data.contact.state.state" readonly />
              </mat-form-field>
            </div>
            <div *ngIf="data.contact?.country?.country" class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Country</mat-label>
                <input matInput type="text" name="Country" [(ngModel)]="data.contact.country.country" readonly />
              </mat-form-field>
            </div>
          </div>
  
  
          <h3>Geolocation Information</h3>
  
          <div class="row" style="width: 100%">
            <div *ngIf="data.contact?.ipinfoCity" class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>City</mat-label>
                <input matInput type="text" name="ipinfoCity" [(ngModel)]="data.contact.ipinfoCity" readonly />
              </mat-form-field>
            </div>
            <div *ngIf="data.contact?.ipinfoRegionname" class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Region</mat-label>
                <input matInput type="text" name="ipinfoRegionname" [(ngModel)]="data.contact.ipinfoRegionname"
                  readonly />
              </mat-form-field>
            </div>
            <div *ngIf="data.contact?.ipinfoZip" class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Zip</mat-label>
                <input matInput type="text" name="ipinfoZip" [(ngModel)]="data.contact.ipinfoZip" readonly />
              </mat-form-field>
            </div>
            <div *ngIf="data.contact?.ipinfoCountry" class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Country</mat-label>
                <input matInput type="text" name="ipinfoCountry" [(ngModel)]="data.contact.ipinfoCountry" readonly />
              </mat-form-field>
            </div>
            <div *ngIf="data.contact?.ipinfoTimezone" class="col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Timezone</mat-label>
                <input matInput type="text" name="ipinfoTimezone" [(ngModel)]="data.contact.ipinfoTimezone" readonly />
              </mat-form-field>
            </div>
  
  
          </div>
  
  
          <div *ngIf="data.contact.imageCod" class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating">File Attached</label>
              <p>
                <a target="_blank" href="https://greenteksolutionsllc.com/uploads/mails/{{data.contact.imageCod}}"><i
                    class="material-icons"> attach_file </i>
                  https://greenteksolutionsllc.com/uploads/mails/{{data.contact.imageCod}}</a>
              </p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating">Description</label>
              <div class="form-group">
                <textarea name="descripcion" class="form-control" rows="5" name="contactDescription"
                  [(ngModel)]="data.contact.descripcion" [readonly]="editContact"></textarea>
              </div>
            </div>
          </div>
          <div class="col-md-12" *ngIf="data.contact.commentsAdmin != null">
            <div class="form-group">
              <label>Comments Admin</label>
              <div class="form-group">
                <textarea name="descripcion" class="form-control" rows="5" readonly>
  {{data.contact.commentsAdmin}}</textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="text-align: right">
              <button class="btn btn-danger" *ngIf="!editContact" (click)="editContact = true">
                <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Back
              </button>
              &nbsp;
              <button class="btn btn-primary" *ngIf="!editContact" (click)="editContactFunction()">
                <i *ngIf="saveContact" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                <i *ngIf="!saveContact" class="fa fa-floppy-o" aria-hidden="true"></i>
                &nbsp; Save
              </button>
              <button class="btn btn-warning" *ngIf="editContact" (click)="editContact = false">
                <i class="fa fa-pencil" aria-hidden="true"></i>
                &nbsp; Edit
              </button>
            </div>
          </div>
        </div>
  
        <div class="row" *ngIf="!editHistory">
          <div class="col-md-12" style="margin-top: 30px">
            <h3>Lead Ranking</h3>
            <hr />
            <h4 class="mb-2" *ngIf="statusLead == '' || statusLead == null">
              Please Rate This Lead!
            </h4>
  
            <h4 *ngIf="statusLead != ''" style="font-weight: 500; color: coral">
              {{statusLead}}
            </h4>
          </div>
        </div>
  
        <div class="d-flex" *ngIf="!editHistory">
          <div *ngFor="let ranking of rankings" class="mr-2 d-flex flex-column align-items-center"
            [ngClass]="[this.statusLead == ranking.value ? 'leadselected' : '']">
            <img (click)="setranking(ranking.value)" class="imageLead mt-4" [src]="ranking.src" />
            <span class="my-4">{{ranking.label}}</span>
          </div>
          <style type="text/css">
            .imageLead {
              max-width: 60%;
              transition: transform 0.2s;
            }
  
            .imageLead:hover {
              cursor: pointer;
              transform: scale(1.5);
            }
  
            .leadselected {
              max-width: 65%;
              border: 1px solid black;
              -webkit-box-shadow: #dadada 0 0 5px;
              -moz-box-shadow: #130e0e 0 0 5px;
              box-shadow: #dadada 0 0 5px;
            }
  
            input:read-only {
              background-color: #fafafa;
              cursor: not-allowed;
            }
          </style>
        </div>
        <hr />
  **
        <div class="row" *ngIf="this.userinterno !== undefined">
          <div class="col-md-12">
            <h4 *ngIf="!editHistory">Add New History</h4>
            <hr />
            <h4 *ngIf="editHistory">Edit History</h4>
            <hr />
          </div>
          <div class="col-md-6">
            <mat-form-field class="example-full-width">
              <mat-label>Purchasing REP</mat-label>
              <input matInput type="text" name="Purchasing REP" value="{{identity.name}} {{identity.surname}}" readonly />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-full-width">
              <mat-label>Contact Date</mat-label>
              <input matInput [matDatepickerFilter]="dateFilter" [matDatepicker]="contactDate" name="Contact Date"
                [(ngModel)]="contacthistory.fechacontacto" />
              <mat-datepicker-toggle matIconSuffix [for]="contactDate"></mat-datepicker-toggle>
              <mat-datepicker #contactDate></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <div class="">
              <label class="">Contact Hour</label>
              <input type="time" class="form-control" min="00:00:00" max="23:59:00" name="horacontacto"
                [(ngModel)]="contacthistory.horacontacto" />
            </div>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill">
              <mat-label>Send a Reminder?</mat-label>
              <select name="reminder" id="reminder" [(ngModel)]="contacthistory.reminder" required matNativeControl>
                <option value="null" disabled>
                  Please select an option
                </option>
                <option value="YES">Yes</option>
                <option value="NO">No</option>
              </select>
            </mat-form-field>
          </div>
  
          <div *ngIf="contacthistory.reminder == 'YES'" class="col-md-3">
            <mat-form-field class="example-full-width">
              <mat-label>Reminder Date</mat-label>
              <input matInput [matDatepicker]="reminderDate" [(ngModel)]="contacthistory.fecha" />
              <mat-datepicker-toggle matIconSuffix [for]="reminderDate"></mat-datepicker-toggle>
              <mat-datepicker #reminderDate></mat-datepicker>
            </mat-form-field>
          </div>
          <div *ngIf="contacthistory.reminder == 'YES'" class="col-md-3">
            <div class="">
              <label class="">Reminder Hour</label>
              <input type="time" class="form-control" min="00:00:00" max="23:59:00" name="hora" #hora="ngModel"
                [(ngModel)]="contacthistory.hora" />
            </div>
          </div>
          <div class="col-md-3" *ngIf="contacthistory.reminder == 'YES'">
            <div class="form-group">
              <mat-checkbox class="check-margin" name="email" [(ngModel)]="contacthistory.email">
                Email
              </mat-checkbox>
            </div>
          </div>
          <div class="col-md-3" *ngIf="contacthistory.reminder == 'YES'">
            <div class="form-group">
              <mat-checkbox class="check-margin" name="notification" [(ngModel)]="contacthistory.notification">
                Notification
              </mat-checkbox>
            </div>
          </div>
          <div class="col-md-3" *ngIf="contacthistory.reminder == 'YES'">
            <button type="button" class="btn btn-primary" (click)="openUsersModal();">
              Add people to reminder
            </button>
          </div>
  
          <div class="col-md-12">
            <div class="form-group">
              <label>Things to remember</label>
              <div class="form-group">
                <textarea name="descripcion" #descripcion="ngModel" [(ngModel)]="contacthistory.descripcion"
                  class="form-control" rows="5"></textarea>
              </div>
            </div>
          </div>
  
          <div class="col-md-12">
            <app-multi-files *ngIf="data && data.contact && data.contact.id" [idfather]="data.contact.id"
              [type]="'MyLeadFiles'"></app-multi-files>
          </div>
  
          <div *ngIf="editHistory" class="row">
            <div class="col-12" style="text-align: right">
              <button class="btn btn-danger" (click)="cleanContact()">
                <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Back
              </button>
              &nbsp;
              <button class="btn btn-primary" [disabled]="saveEditHistory" (click)="editContactHistory()">
                <i *ngIf="saveEditHistory" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                <i *ngIf="!saveEditHistory" class="fa fa-floppy-o" aria-hidden="true"></i>
                &nbsp; Save
              </button>
            </div>
          </div>
        </div>
        <div mat-dialog-actions *ngIf="!editHistory">
          <button *ngIf="this.userinterno !== undefined" type="submit" (click)="onSubmit()" style="margin-left: 10px"
            class="btn btn-success">
            Save History
          </button>
        </div>
  
        <br />
        <hr />
  *
        <div *ngIf="!editHistory && this.userinterno !== undefined" class="col-md-12" style="margin-top: 30px">
          <hr />
          <h3>Contact History</h3>
          <hr />
          <br />
  
          <div class="material-datatables">
            <table id="datatables1" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%"
              style="width: 100%">
              <thead>
                <tr>
                  <th>{{ tableContacts.headerRow[0] }}</th>
                  <th class="text-center">
                    {{ tableContacts.headerRow[1] }}
                  </th>
                  <th class="text-center">
                    {{ tableContacts.headerRow[2] }}
                  </th>
                  <th class="text-center">
                    {{ tableContacts.headerRow[3] }}
                  </th>
                  <th class="text-center">
                    {{ tableContacts.headerRow[4] }}
                  </th>
                  <th class="disabled-sorting text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr id="contacthistoryregistry{{row[0]}}" *ngFor="let row of tableContacts.dataRows">
                  <td>{{row[0]}}</td>
                  <td class="text-center">{{row[1]}}</td>
                  <td class="text-center">
                    {{row[2] * 1000 | date:'MM-dd-yyyy'}}
                  </td>
                  <td class="text-center">
                    {{row[3] * 1000 | date:'MM-dd-yyyy'}}
                  </td>
                  <td class="text-center">{{row[4]}}</td>
                  <td class="text-right">
                    <a (click)="getContactHistory(row[0])" class="btn btn-link btn-warning btn-just-icon" title="Edit"><i
                        class="material-icons">edit</i></a>
                    <a (click)="deleteContactHistory(row[0])" class="btn btn-link btn-danger btn-just-icon"
                      title="Delete"><i class="material-icons">delete_forever</i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <br /><br />
        </div>
  
        <div mat-dialog-actions *ngIf="!editHistory">
          <button type="button" class="btn btn-success" data-dismiss="modal" (click)="close()">
            Close
          </button>
        </div>
      </form>
    </div>

  </div>
</div>  -->

<!-- <div
  class="modal fade"
  id="enableUsersModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  aria-labelledby="exampleModalScrollableTitle"
  aria-hidden="true"
  *ngIf="contacthistory.reminder == 'YES'"
>
  <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalScrollableTitle">
          <b>Enable Users</b>
        </h3>
        <button
          type="button"
          class="close"
          (click)="closeUsersModal(1)"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <h4>Enable Users</h4>
          <form>
            <div class="col-md-12">
              <mat-form-field class="example-full-width">
                <input
                  matInput
                  [formControl]="myControlUsers"
                  placeholder="Search"
                  type="text"
                />
              </mat-form-field>
            </div>
          </form>
        </div>

        <div class="row">
          <div class="col-12">
            <p>Scroll</p>
            <section class="scroll">
              <div
                *ngFor="let item of filteredArrayUsers | async"
                class="row notify"
              >
                <div class="col-8">
                  <div class="row" (click)="seleccionarUser(item.id)">
                    <div class="col-8">
                      <a class="btn btn-link btn-primary btn-just-icon">
                        <i class="material-icons"
                          >{{chequeadoUser(item.id) ? 'check_box' :
                          'check_box_outline_blank'}}</i
                        >
                      </a>
                      <span>{{item.name | titlecase }} {{item.surname}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          (click)="closeUsersModal(1)"
        >
          Close
        </button>
        &nbsp;&nbsp;
        <button
          type="button"
          class="btn btn-primary"
          (click)="closeUsersModal(2)"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div> -->
